import { Utensils, Car, Ticket, ParkingCircle, Train, BedDouble, ShoppingBag, Receipt } from "lucide-react";
export const CATEGORIES = {
  meal: { label: "Restauration", icon: Utensils }, mileage: { label: "Indemnité kilométrique", icon: Car },
  toll: { label: "Péage", icon: Ticket }, parking: { label: "Stationnement", icon: ParkingCircle },
  transport: { label: "Train, taxi, transport", icon: Train }, hotel: { label: "Hébergement", icon: BedDouble },
  supplies: { label: "Fournitures", icon: ShoppingBag }, other: { label: "Autre dépense", icon: Receipt },
};
export const STATUSES = {
  draft: { label: "Brouillon", className: "bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300" },
  submitted: { label: "À valider", className: "bg-amber-50 text-amber-800 dark:bg-amber-950/40 dark:text-amber-300" },
  approved: { label: "Validé", className: "bg-emerald-50 text-emerald-800 dark:bg-emerald-950/40 dark:text-emerald-300" },
  rejected: { label: "Refusé", className: "bg-rose-50 text-rose-800 dark:bg-rose-950/40 dark:text-rose-300" },
};
export const money = cents => new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format((cents || 0) / 100);
export const km = meters => new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 3 }).format((meters || 0) / 1000);
export const localDate = () => new Date().toLocaleDateString("fr-CA");
export const dateLabel = date => new Date(`${date}T00:00:00`).toLocaleDateString("fr-FR");
export const apiError = err => {
  const detail = err.response?.data?.detail;
  return typeof detail === "string" ? detail : Array.isArray(detail) ? detail.map(item => item.msg.replace(/^Value error, /, "")).join(" · ") : "Action impossible. Vérifiez votre connexion et réessayez.";
};
export const saveBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob); const link = document.createElement("a"); link.href = url; link.download = filename;
  document.body.appendChild(link); link.click(); link.remove(); setTimeout(() => URL.revokeObjectURL(url), 60000);
};
export const RECEIPT_ACCEPT = ".pdf,.png,.jpg,.jpeg,.webp,.gif";